export enum EInvoiceFormat {
  ZUG_FE_RD = 'ZUG_FE_RD',
  X_RECHNUNG = 'X_RECHNUNG',
  PDF = 'PDF',
}
